/**
 * @flow
 * @relayHash 1476f9c8972dbbe130faff20d901f2a8
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddUserQueryVariables = {||};
export type AddUserQueryResponse = {|
  +sites: ?$ReadOnlyArray<?{|
    +siteName: ?string,
    +pk: ?number,
  |}>
|};
export type AddUserQuery = {|
  variables: AddUserQueryVariables,
  response: AddUserQueryResponse,
|};
*/


/*
query AddUserQuery {
  sites {
    siteName
    pk
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sites",
    "storageKey": null,
    "args": null,
    "concreteType": "SiteDetails",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "siteName",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "pk",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddUserQuery",
    "type": "RelayQuery",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddUserQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "AddUserQuery",
    "id": null,
    "text": "query AddUserQuery {\n  sites {\n    siteName\n    pk\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c72aaf93c551191b69b9fef182bd1695';
module.exports = node;
